<app-ciq-dialog
    label="Welcome to CollectivIQ, your AI workforce platform."
    [lightDismiss]="false"
    [open]="isOpen()"
    (openChange)="onOpenChange($event)">
    <div class="meet" data-testid="meet-your-team-dialog">
        <p class="meet-copy">
            Next we're going to hire your DDRs, your Digital Direct Reports. They're AI teammates, each with a job to do and its own chat.
        </p>
        <ul class="meet-roles">
            @for (role of roles; track role.archetype) {
                <li class="meet-role" data-testid="meet-your-team-role" [style.--role-accent]="role.accent">
                    <span aria-hidden="true" class="meet-role-icon"><wa-icon [name]="role.icon" /></span>
                    <app-role-chip [subject]="{ archetype: role.archetype }" />
                    <span class="meet-role-line">{{ role.line }}</span>
                </li>
            }
        </ul>
        <div class="meet-footer">
            <div class="meet-alice">
                @if (alice()?.avatar_url) {
                    <img alt="" class="meet-alice-avatar" [src]="alice()?.avatar_url" />
                } @else {
                    <span aria-hidden="true" class="meet-alice-avatar meet-alice-initial">A</span>
                }
                <span class="meet-copy">Alice Hunter is your DDR talent lead. She's going to help you hire your first three DDRs now.</span>
            </div>
            <div class="meet-actions">
                <wa-button appearance="plain" data-testid="meet-your-team-later" size="small" variant="neutral" (click)="later()"
                    >Later</wa-button
                >
                <wa-button appearance="filled" data-testid="meet-your-team-go" size="small" variant="brand" (click)="meetAlice()"
                    >Let's go</wa-button
                >
            </div>
        </div>
    </div>
</app-ciq-dialog>
